module.exports = __webpack_public_path__ + "img/prawn-and-vegetable-curry.02209fb7.jpg";